import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-section-study-materials',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './section-study-materials.component.html',
  styleUrl: './section-study-materials.component.css'
})
export class SectionStudyMaterialsComponent {

}
